export function viewFourRemoveStep(state, payload) {
  return {
    ...state,
    designChapter: updateDesignChapter(state.designChapter, payload),
  };
}

function updateDesignChapter(designChapter, payload) {
  const updateInSlideTree = (slideTree) => {
    return slideTree.map((groupItem) => {
      if (payload.groupId === groupItem.groupId)
        return {
          ...groupItem,
          groupNodes: groupItem.groupNodes.map(updateGroupNode),
        };
      else return { ...groupItem };
    });
  };

  const updateGroupNode = (groupNode) => {
    if (groupNode.nodeId === payload.nodeId) {
      return {
        ...groupNode,
        nodeComponents: groupNode.nodeComponents.map(updateNodeComponent),
      };
    } else return { ...groupNode };
  };

  let droppedOptionId = undefined;

  const updateNodeComponent = (nodeComponent) => {
    if (nodeComponent.id === payload.positionId) {
      droppedOptionId = nodeComponent.droppedId;
      return { ...nodeComponent, droppedId: null };
    }
    return { ...nodeComponent };
  };

  const updateDroppedOptionVisibility = (optionItem) => {
    return {
      ...optionItem,
      list: optionItem.list.map((listItem) => {
        if (listItem.id === droppedOptionId)
          return { ...listItem, visible: true };
        return { ...listItem };
      }),
    };
  };

  return {
    ...designChapter,
    currentView: {
      ...designChapter.currentView,
      slideTree: updateInSlideTree(designChapter.currentView.slideTree),
      options: designChapter.currentView.options.map(
        updateDroppedOptionVisibility
      ),
    },
  };
}
